import { Component, OnInit, OnDestroy } from '@angular/core';
import { UtilsService } from 'app/components/utils/utils.service';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';
import { DomService } from 'app/components/dom/dom.service';

@Component({
  selector: 'app-general-information',
  templateUrl: './general-information.component.html',
  styleUrls: ['./general-information.component.css']
})
export class GeneralInformationComponent implements OnInit, OnDestroy {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';
  catalogueProperties: any = {};

  constructor(public utilsService: UtilsService, public catalogueService: CatalogueService, private domService: DomService) { }

  goToMaps(place) {

    let url = 'https://www.google.com/maps/place/Fira+Barcelona+Gran+Via/@41.3546937,2.1278252,17z/data=!3m1!4b1!4m6!3m5!1s0x12a4a279649aa111:0xb0d0cc966887d153!8m2!3d41.3546937!4d2.1278252!16s%2Fg%2F1thj71sc?entry=ttu';

    if (place !== 'granVia') {
      url = 'https://www.google.com/maps/place/Fira+Internacional+de+Barcelona/@41.3738867,2.150208,17z/data=!4m14!1m7!3m6!1s0x12a4a27ba652ef8f:0x7d0d287990636de7!2sFira+Internacional+de+Barcelona!8m2!3d41.3737762!4d2.1491729!16s%2Fm%2F0dr_tzq!3m5!1s0x12a4a27ba652ef8f:0x7d0d287990636de7!8m2!3d41.3737762!4d2.1491729!16s%2Fm%2F0dr_tzq?entry=ttu'
    }

    window.open(url);

  }

  ngOnInit() {
    
    this.catalogueService.getDataProperties().subscribe(data => {
      this.catalogueProperties = data;
    });

    this.domService.addClassToBody('bg-gray');
  }

  ngOnDestroy() {
    this.domService.removeClassFromBody('bg-gray');
  }

}

